import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { GlobalStyles } from './styles/GlobalStyles';
import { AdminAuthProvider } from './admin/context/AdminAuthContext';
import { applyGoogleTranslation, getSavedLanguage, initGoogleTranslate } from './i18n/googleTranslate';
import { startCurrencyNormalization } from './i18n/currencyNormalizer';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Public Pages
import Home from './pages/Home';
import Institution from './pages/Institution';
import Actualites from './pages/Actualites';
import Galerie from './pages/Galerie';
import Services from './pages/Services';
import DepotPlainte from './pages/DepotPlainte';
import Suivi from './pages/SuiviPlainte';
import Methodologie from './pages/Methodologie';
import Formulaires from './pages/Formulaires';
import Signalement from './pages/Signalement';
import Observatoire from './pages/Observatoire';
import Documents from './pages/Documents';
import Rapports from './pages/Rapports';
import Etudes from './pages/Etudes';
import TextesJuridiques from './pages/TextesJuridiques';
import Partenaires from './pages/Partenaires';
import Cooperation from './pages/Cooperation';
import Contact from './pages/Contact';
import Historique from './pages/Historique';
import RolesMissions from './pages/RolesMissions';
import EquipeDirigeante from './pages/EquipeDirigeante';
import Communiques from './pages/Communiques';
import ArticleDetail from './pages/ArticleDetail';

// Admin Pages
import AdminLogin from './admin/pages/Login';
import AdminDashboard from './admin/pages/Dashboard';
import AdminCommuniques from './admin/pages/AdminCommuniques';
import AdminActualites from './admin/pages/AdminActualites';
import AdminGalerie from './admin/pages/AdminGalerie';
import AdminRapports from './admin/pages/AdminRapports';
import AdminEtudes from './admin/pages/AdminEtudes';
import AdminConflits from './admin/pages/AdminConflits';
import AdminUsers from './admin/pages/AdminUsers';
import AdminArticles from './admin/pages/AdminArticles';
import AdminPlaintes from './admin/pages/AdminPlaintes';
import AdminContacts from './admin/pages/AdminContacts';
import AdminParametres from './admin/pages/AdminParametres';

import MotDuMediateur from './pages/MotDuMediateur';
const Organigramme = () => <div>Page Organigramme</div>;


function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    initGoogleTranslate();
  }, []);

  useEffect(() => {
    const stopNormalization = startCurrencyNormalization();
    return () => stopNormalization();
  }, []);

  useEffect(() => {
    const lang = getSavedLanguage();
    if (lang === 'fr') return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      const translated = applyGoogleTranslation(lang);
      if (translated || attempts > 20) {
        window.clearInterval(timer);
      }
    }, 250);

    return () => window.clearInterval(timer);
  }, [location.pathname]);

  return (
    <>
      <GlobalStyles />
      <div id="google_translate_element" style={{ display: 'none' }} />
      {!isAdminRoute && <Header />}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/institution" element={<Institution />} />
        <Route path="/institution/mot" element={<MotDuMediateur />} />
        <Route path="/institution/historique" element={<Historique />} />
        <Route path="/institution/roles" element={<RolesMissions />} />
        <Route path="/institution/organigramme" element={<Organigramme />} />
        <Route path="/institution/equipe" element={<EquipeDirigeante />} />
        <Route path="/actualites" element={<Actualites />} />
        <Route path="/actualites/communiques" element={<Communiques />} />
        <Route path="/actualites/galerie" element={<Galerie />} />
        <Route path="/actualites/:id" element={<ArticleDetail />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/depot-plainte" element={<DepotPlainte />} />
        <Route path="/services/signalement" element={<Signalement />} />
        <Route path="/services/suivi" element={<Suivi />} />
        <Route path="/services/methodologie" element={<Methodologie />} />
        <Route path="/services/formulaires" element={<Formulaires />} />
        <Route path="/observatoire" element={<Observatoire />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/documents/rapports" element={<Rapports />} />
        <Route path="/documents/etudes" element={<Etudes />} />
        <Route path="/documents/textes-juridiques" element={<TextesJuridiques />} />
        <Route path="/partenaires" element={<Partenaires />} />
        <Route path="/partenaires/cooperation" element={<Cooperation />} />
        <Route path="/contact/*" element={<Contact />} />

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/communiques" element={<AdminCommuniques />} />
        <Route path="/admin/actualites" element={<AdminActualites />} />
        <Route path="/admin/galerie" element={<AdminGalerie />} />
        <Route path="/admin/parametres" element={<AdminParametres />} />
        <Route path="/admin/rapports" element={<AdminRapports />} />
        <Route path="/admin/etudes" element={<AdminEtudes />} />
        <Route path="/admin/conflits" element={<AdminConflits />} />
        <Route path="/admin/utilisateurs" element={<AdminUsers />} />
        <Route path="/admin/articles" element={<AdminArticles />} />
        <Route path="/admin/plaintes" element={<AdminPlaintes />} />
        <Route path="/admin/contacts" element={<AdminContacts />} />
      </Routes>
      {!isAdminRoute && <Footer />}
    </>
  );
}

function App() {
  return (
    <AdminAuthProvider>
      <AppContent />
    </AdminAuthProvider>
  );
}

export default App;
